import React, { useEffect, useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus } from 'Enums';
import { useApiError, useCaregiver, useToast } from 'Hooks';
import { Link, Main, Spinner, TitleActionBar } from 'Components/utility';
import { cutString } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { logout } from 'Utilities/session';
const CaregiverConnection = ({ data: { caregiverConnection } }) => {
    const [footerLoading, setFooterLoading] = useState(false);
    const [mainLoading, setMainLoading] = useState(true);
    const { showApiErrorModal } = useApiError();
    const { showToast } = useToast();
    const { removeCaregiverConnection, showStopSharingModal } = useCaregiver();
    useEffect(() => {
        if (!caregiverConnection) {
            mediator.publish('router:navigate', '/connections');
        }
        setMainLoading(false);
    }, [caregiverConnection]);
    const onStopSharing = () => {
        showStopSharingModal(async () => {
            try {
                setFooterLoading(true);
                await removeCaregiverConnection(caregiverConnection);
                showToast({
                    message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
                    'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved'),
                });
                mediator.publish('router:navigate', '/connections');
            }
            catch (err) {
                const error = err;
                if (error.status === ApiStatus.UNAUTHORIZED) {
                    logout();
                    return;
                }
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        });
    };
    if (mainLoading) {
        return React.createElement(Spinner, null);
    }
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "ConnectedCaregiver", title: `${cutString(caregiverConnection.firstName, 10)} ${cutString(caregiverConnection.lastName, 10)}`, closeBtn: true }),
        React.createElement(Stack, { margin: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$-1" },
            React.createElement(Text, { testID: "ConnectedCaregiver.title", color: "$text.100", fontWeight: "$h3.strong", fontSize: "$h3.strong" }, i18n.t('Connections.content.connectedCaregiver.primaryText')),
            React.createElement(Text, { testID: "ConnectedCaregiver.bodyText", marginTop: "$2", color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default" }, i18n.t('Connections.content.connectedCaregiver.secondaryText')),
            React.createElement(Text, { testID: "ConnectedCaregiver.email-label", marginTop: "$8", color: "$text.60", fontWeight: "$bodySmall.default", fontSize: "$bodySmall.default" }, i18n.t('Connections.content.connectedCaregiver.bodyText')),
            React.createElement(Text, { testID: "ConnectedCaregiver.email", color: "$text.100", fontWeight: "$bodyBase.medium", fontSize: "$bodyBase.medium" }, caregiverConnection.email),
            React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" }),
            footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
                React.createElement(LoadingSpinner, null))) : (React.createElement(Link, { testID: "ConnectedCaregiver.stopSharing-btn", onPress: onStopSharing, textColor: "$support.danger.default" }, i18n.t('Connections.content.connectedCaregiver.links.stopSharing.label'))))));
};
export default CaregiverConnection;
